"use client";

import { Button } from "@/components/ui/button";
import { SettingsCard } from "@/components/editor/settings/settings-card";
import { googleAdsEnabled, GOOGLE_ADS_OPEN_SETTINGS_EVENT } from "@/lib/analytics/google-ads-config";

export function GoogleAdsSettings() {
    if (!googleAdsEnabled()) return null;
    return (
        <SettingsCard title="Ad measurement" description="Choose whether Google can measure your signup from our ads. You can change or withdraw permission anytime.">
            <Button variant="outline" onClick={() => window.dispatchEvent(new Event(GOOGLE_ADS_OPEN_SETTINGS_EVENT))}>
                Ad measurement settings
            </Button>
        </SettingsCard>
    );
}
